import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Home from './components/Home';
import WhoWeAre from './pages/WhoWeAre';
import OurCoreXperts from './pages/OurCoreXperts';
import OurInterns from './pages/OurInterns';
import OurServices from './pages/OurServices';
import Blog from './pages/Blog';
import Careers from './pages/Careers';
import CareersBenefits from './pages/Careers';
import Contact from './components/Contact';
import RequestQuote from './pages/Quote';
import ThankYou from './pages/ThankYou';
import CustomSoftware from './pages/custom-software-development';
import ITConsulting from './pages/it-support-services';
import CloudServices from './pages/cloud-service-providers';
import BusinessProcessOutsourcing from './pages/bpo-services';
import AIChatbotServices from './pages/ai-chatbot-development-services';
import DigitalMarketingServices from './pages/digital-marketing-services';
import UIUXDesignServices from './pages/UIUXDesignServices';
import LauraTekLMS from './pages/lauratek';
import Shrava360 from './pages/Shrava360';
import OneStepMedi from './pages/OneStepMedi';
import SEO2025 from './pages/seo-blogs';
import Software2025 from './pages/software-2025';
import DigitalMarketing2025 from './pages/software-2025';
import TermsAndConditions from './pages/terms';
import TermsAndConditionsAlt from './pages/terms';
import CustomvsPrebuiltSoftware from './pages/custom-software-development';
import './App.css';
import OffPageSEO from './pages/OffPageSEO';
import BestSoftwareDevelopment from './pages/BestSoftwareDevelopment'
import Products from './pages/OurProducts';
import LauraDashboard from './pages/laura_dashboard'
import CybersecurityServices from './pages/cybersecurity';
import SEO2025Strategies from './pages/seo-strategies';
import SEOStrategies from './pages/seo-strategies';
import ArogyaNarayan from './pages/ArogyaNarayan';
import Vishan from './pages/Vishan';
import LogSphere from './pages/Hisphere';
import LauraTek from './pages/Lauratek2.0';
import DeviceAnalytics from './pages/Logsphere';
import DevTalent from './pages/devtalent';
import RobAndGrab from './pages/RobnGrab';
import ScrollToTop from "./components/ScrollToTop";
import SEO from './components/SEO';
import NotFound from './pages/NotFound';


function App() {
  return (
    <Router>
      <SEO />
      <ScrollToTop />
      <div className="App">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/ArogyaNarayan" element={<ArogyaNarayan/>} />
          <Route path="/Vishan" element={<Vishan/>} />
          <Route path="/hisphere" element={<LogSphere/>} />
          <Route path="/Lauratek2.0" element={<  LauraTek/>} />
          <Route path="/Logsphere" element={<  DeviceAnalytics/>} />
          <Route path="/devtalent" element={<  DevTalent/>} />
          <Route path="/RobnGrab" element={<RobAndGrab/>} />
          

                    <Route path="/who-we-are" element={<WhoWeAre />} />
          <Route path="/our-corexperts" element={<OurCoreXperts />} />
          <Route path="/our-interns" element={<OurInterns />} />
          <Route path="/our-services" element={<OurServices />} />
          <Route path="/our-products" element={<Products />} />
          <Route path="/blogs" element={<Blog />} />
          <Route path="/careers" element={<Navigate to="/Careers&Benefits" replace />} />
          <Route path="/Careers&Benefits" element={<CareersBenefits />} />
          <Route path="/contact-us" element={<Contact />} />
          <Route path="/get-quoted" element={<RequestQuote />} />
          <Route path="/thank-you" element={<ThankYou />} />
          <Route path="/custom-software-development" element={<CustomSoftware />} />
          <Route path="/Custom_vs_Prebuilt_Software" element={<CustomvsPrebuiltSoftware />} />
          <Route path="/it-support-services" element={<ITConsulting />} />
          <Route path="/cloud-service-providers" element={<CloudServices />} />
          <Route path="/bpo-services" element={<BusinessProcessOutsourcing />} />
          <Route path="/ai-chatbot-development-services" element={<AIChatbotServices />} />
          <Route path="/digital-marketing-services" element={<DigitalMarketingServices />} />
          <Route path="/ui-ux-design-services" element={<UIUXDesignServices />} />
          <Route path="/cybersecurity-services" element={<CybersecurityServices />} />
          <Route path="/lauratek" element={<LauraTekLMS />} />
          <Route path="/Shrava360" element={<Shrava360/>} />
          <Route path="/one_step_medi" element={<OneStepMedi />} />
          <Route path="/seo-blogs" element={<SEO2025 />} />
          <Route path="/software-2025" element={<Navigate to="/digital_marketing_2025" replace />} />
          <Route path="/digital_marketing_2025" element={<DigitalMarketing2025 />} />
          <Route path="/seo-strategies" element={< SEO2025Strategies />} />
          <Route path="/seostrategies" element={<SEOStrategies />} />
          <Route path="/OffPageSEO" element={< OffPageSEO />} />
          <Route path="/terms" element={<Navigate to="/terms&conditions" replace />} />
          <Route path="/terms&conditions" element={<TermsAndConditionsAlt />} />
          <Route path="/BestSoftwareDevelopment" element={<BestSoftwareDevelopment />} />
          <Route path="/laura_dashboard" element={<LauraDashboard />} />

          
           
          <Route path="/connect-landing" element={<div>Connect Landing Page</div>} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </div>
    </Router>
  );
}
 
export default App;